import { all, takeEvery } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'

import screen from '../screen/sagas'
import api from '../api/sagas'
import collectionlist from '../collectionlist/sagas'
import settings from '../settings/sagas'
import lockapp from '../lockapp/sagas'
import bundles from '../bundles/sagas'
import collectionownership from '../collectionownership/sagas'
import maps from '../map/sagas'
import mediaitems from '../mediaitems/sagas'
import forms from '../forms/sagas'
import { readyAction } from './actions'

import { getConfiguration } from '../configuration/index'

function* handleReady(): SagaIterator {
	// was setting ApiConfig but thats now done directly from the persistCallback as needed to be done earlier
}

function* readySaga(): SagaIterator {
	yield takeEvery(readyAction, handleReady)
}

/** The root saga that starts all of the other sagas. */
export default function* rootSaga() {
	yield all([
		screen(),
		api(),
		collectionlist(),
		settings(),
		lockapp(),
		bundles(),
		collectionownership(),
		readySaga(),
		maps(),
		mediaitems(),
		forms(),
		getConfiguration().getSagas(),
	])
}
